export { default as laying12Bronzing } from './laying-12-bronzing.jpeg'
export { default as laying14Bronzing } from './laying-14-bronzing.jpeg'
export { default as standing14Bronzing } from './standing-14-bronzing.jpg'
